<template>
    <v-main v-if="checkedToken">
        <v-row class="ma-0">
            <v-col sm="6" class="d-flex align-end justify-end pb-5 pr-5">
                <strong class="white--text">&copy; {{ new Date().getFullYear() }} TCO TEAM.</strong>
            </v-col>
            <v-col sm="6" class="d-flex justify-center align-center">
                <section class="d-flex flex-column align-center">
                    <router-link :to="{name : 'Home'}">
                        <img :src="require('@/../public/images/TcoTeam.png')">
                    </router-link>

                    <h1>{{$t("auth.new_password")}}</h1>

                    <p class="mb-11">{{$t("auth.description")}}</p>

                    <section class="sectionForm">
                        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                            <v-form @submit.prevent="handleSubmit(submit)">
                                <ValidationProvider vid="password" :name="$t('auth.new_password')" rules="required|min:6" v-slot="{ errors }">
                                    <v-text-field :label="$t('auth.new_password')"
                                                  type="password"
                                                  v-model="user.password"
                                    >
                                        <template v-slot:prepend-inner>
                                            <svg v-svg="'icon-password'" size="15" class="mr-1"></svg>
                                        </template>
                                    </v-text-field>
                                    <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                                </ValidationProvider>

                                <ValidationProvider :name="$t('auth.password')" rules="required|confirmed:password" v-slot="{ errors }">
                                    <v-text-field :label="$t('auth.password')"
                                                  type="password"
                                                  v-model="user.password_confirmation"
                                    >
                                        <template v-slot:prepend-inner>
                                            <svg v-svg="'icon-password'" size="15" class="mr-1"></svg>
                                        </template>
                                    </v-text-field>
                                    <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                                </ValidationProvider>

                                <v-card-actions class="justify-center mt-7">
                                    <v-btn class="white--text" color="green" type="submit" :loading="loadingRequest" width="90" height="30">{{$t("auth.login")}}</v-btn>
                                </v-card-actions>
                            </v-form>
                        </ValidationObserver>
                    </section>
                </section>

                <v-footer fixed class="d-none transparent mb-3">
                    <strong class="mx-auto">&copy; {{ new Date().getFullYear() }} TCO TEAM.</strong>
                </v-footer>
            </v-col>
        </v-row>
    </v-main>
</template>

<script>
    export default {
        data(){
            return {
                user: {token: this.$route.query.token},
                loadingRequest : false,
                checkedToken: false,
            }
        },

        mounted() {
            this.$api('auth').checkRestoreToken({'token': this.$route.query.token})
                .then((res) => {if(res.status === 200) this.checkedToken = true})
                .catch((err) => {if(err.response.status === 422) this.$router.push({name : 'Error404'})})
        },

        methods: {
            submit(){
                this.loadingRequest = true;
                this.$api('auth').newPassword(this.user)
                    .then((res) => {
                        this.$store.dispatch('alert', {type: 1, message: res.data.message})
                        this.$store.dispatch('LOGIN_HOME', res.data);
                        this.$router.push({name : 'Blog'});
                    }).catch((err) => {
                    let response = err.response;
                    if (response.status === 422) this.$refs.form.setErrors(response.data);
                }).finally(() => {
                    this.loadingRequest = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/auth";
</style>